<template>
  <div class="chatvisa-frame-header">
      <div class="chatvisa-frame-header-left">
        <div class="icon-logo">
          <img src="https://o.666visa.cn/static/ssqpeer/chatvisa/chatvisa-logo.png" alt="">
        </div>
        <div class="header-left-theme">
          <img class="header-left-title" src="https://o.666visa.cn/static/ssqpeer/chatvisa/chatvisa-brief-title.png" alt="">
          <div class="line-h-11"></div>
          <div class="header-left-text">你的签证AI助手</div>
        </div>
      </div>
      <div class="chatvisa-frame-header-right">
        <!-- <quick-cs-btn type="header"></quick-cs-btn> -->
         <div class="realize-chat-visa" @click="$emit('show-recommend')">了解签问</div>
        <img class="icon-close" @click="closeChatFrame" src="https://o.666visa.cn/static/ssqpeer/chatvisa/chatvisa-close.png" alt="">
      </div>
    </div>
</template>

<script>
import QuickCsBtn from '../../components/quick-cs-btn.vue';

export default {
  props: {
    // page_from: String,
  },
  components: {
    QuickCsBtn,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    closeChatFrame() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
.chatvisa-frame-header{
    flex-shrink: 0;
    width: 100%;
    height: 60px;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient( 270deg, #FFFFFF 0%, #F3F0FF 30%, #F0F6FF 100%);
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.06);
    border-radius: 4px 4px 0px 0px;
    .chatvisa-frame-header-left{
      display: flex;
      justify-content: flex-start;
      gap: 8px;
      height: 36px;
      align-items: center;
      .icon-logo {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: linear-gradient(224deg, #8765ff 0%, #6facff 100%);
        >img{
          display: block;
          width: 23px;
          height: 23px;
        }
      }
      .header-left-theme{
        display: flex;
        justify-content: flex-start;
        gap: 6px;
        height: 22px;
        align-items: center;
        .header-left-title{
          width: 31px;
          height: 16px;
        }
        .line-h-11{
          width: 1px;
          height: 11px;
          border: 1px solid #8765FF;
          opacity: 0.2;
        }
        .header-left-text{
          font-size: 12px;
          color: #5F666E;
        }

      }
    }
    .chatvisa-frame-header-right{
      display: flex;
      justify-content: flex-end;
      height: 36px;
      align-items: center;
      gap: 8px;
      .realize-chat-visa{
        padding: 8px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #E9EEF2;
        backdrop-filter: blur(10px);
        font-size: 12px;
        color: #2F333D;
        cursor: pointer;
      }
      .icon-close{
        display: block;
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/chat-visa/component-external/components/chatvisa-frame-header.vue